selectcategory-window.selectcategory-window
  template(if="{props.type !== 'in_modal'}")
    button.open(class="{ props.type } { props.mobile ? 'sp' : 'pc' }" type="button" onclick="{ didClickOpen }")
      span { props.mobile ? '腕時計カテゴリ' : 'カテゴリを選択' }
      img(if="{ props.mobile }" src="{orangeArrow}" height="22")
    ul.selected-categories(if!="{ state.selectedCategories.length > 0 }" class="{ props.mobile ? 'sp' : 'pc' }")
      template(each="{brand in state.selectedCategories}")
        li
          | { brand.name }
          button(data-categoryid="{ brand.id }" onclick="{didClickRemoveBrand}") ×
        template(each="{model in brand.models}")
          li
            | { model.name }
            button(data-categoryid="{ model.id }" onclick="{didClickRemoveModel}") ×
          template(if!="{ !!model.reference_group && model.reference_group.parent == model.id }")
            li
              | { model.reference_group.name }系
              button(data-groupid="{ model.reference_group.id }"
                    data-groupname="{ model.reference_group.name }"
                    onclick="{ didClickRemoveReferenceGroup }") ×
            template(if="{ !!model.reference_group.reference }")
              li
                | { model.reference_group.reference.name }
                button(data-refid="{ model.reference_group.reference.id }"
                      data-refname="{ model.reference_group.reference.name }"
                      onclick="{ didClickRemoveReference }") ×
          template(if!="{ !!model.reference && model.reference.parent == model.id }")
            li
              | { model.reference.name }
              button(data-refid="{ model.reference.id }"
                    data-refname="{ model.reference.name }"
                    onclick="{ didClickRemoveReference }") ×
    template(if!="{ props.mobile && state.isOpened }")
      .category-selector.sp
        .background
        .select-window
          .header
            .header-title スマート検索カテゴリ選択
            button.close(type="button" onclick="{didClickClose}")
              img.close-icon(src="{closeIcon}")
              | 閉じる
          .description
            | 複数のカテゴリを選択して腕時計を探すことが可能です。例えば「デイトナとスピードマスター」カテゴリを選択するとそれらに該当する腕時計を絞り込むことができます。
          .label ブランドを選択
          ul.brands.scrollable
            template(each="{rootItem in state.rootsAndBrands}")
              template(each="{brand in rootItem.brands}")
                li.category(if="{state.selectedBrands.includes( '' + brand.id )}" data-parent="{ brand.parentId }")
                  label.name
                    img(src="{checkboxOnIcon}" class="checkbox-icon ")
                    input.check(type="checkbox" value="{ brand.id }" onchange="{ didSelectBrand }" checked="{ true }")
                    | { brand.name }
            template(each="{rootItem in state.rootsAndBrands}")
              template(each="{brand in rootItem.brands}")
                li.category(if="{!state.selectedBrands.includes( '' + brand.id )}" data-parent="{ brand.parentId }")
                  label.name
                    img(src="{checkboxOffIcon}" class="checkbox-icon")
                    input.check(type="checkbox" value="{ brand.id }" onchange="{ didSelectBrand }" checked="{ false }")
                    | { brand.name }
          .label.model モデルを選択
          template(if="{ state.selectedBrands.length == 0 }")
            .models
              .unselected
                | ブランド選択後に選択可能なモデルが表示されます
          template(if!="{ state.selectedBrands.length > 0 }")
            .models.scrollable
              template(each="{model in state.models}")
                template(each="{m in model.models}")
                  label.name(if="{ state.selectedModels.includes( '' + m.id ) }")
                    img(src="{checkboxOnIcon}" class="checkbox-icon")
                    input.check(type="checkbox" data-brand="{ model.parentId }" value="{ m.id }" onchange="{ didSelectModel }" checked="{ true }")
                    | { m.name }
              template(each="{model in state.models}")
                template(each="{m in model.models}")
                  label.name(if="{ !state.selectedModels.includes( '' + m.id ) }")
                    img(src="{checkboxOffIcon}" class="checkbox-icon")
                    input.check(type="checkbox" data-brand="{ model.parentId }" value="{ m.id }" onchange="{ didSelectModel }" checked="{ false }")
                    | { m.name }
        button.select-category(type="button" onclick="{didClickSubmit}") 決定
    template(if!="{ !props.mobile && state.isOpened }")
      .category-selector.pc
        .background(onclick="{didClickClose}")
        .select-window
          table
            tr
              th ブランド
              td
                .brands-wrapper
                  .roots
                    button(each="{(rootItem, i) in state.rootsAndBrands}" value="{i}" class="{ rootItem.category.name == state.selectedRoot.category.name ? 'selected' : '' }"
                          onclick="{didSelectRoot}") { rootItem.category.name }
                  template(each="{rootItem in state.rootsAndBrands}")
                    .brands(style="display: { rootItem.category.name == state.selectedRoot.category.name ? 'flex' : 'none' }")
                      template(each="{brand in rootItem.brands}")
                        label
                          input(type="checkbox" value="{ brand.id }" onchange="{ didSelectBrand }"
                                checked="{ state.selectedBrands.includes( '' + brand.id )}")
                          | { brand.name }
            tr
              th モデル
              td
                .models
                  template(each="{model in state.models}")
                    template(each="{m in model.models}")
                      label
                        input(type="checkbox" data-brand="{ model.parentId }" value="{ m.id }" onchange="{ didSelectModel }"
                              checked="{ state.selectedModels.includes( '' + m.id )}")
                        | { m.name }
          .actions
            search-counter(prefix="該当する腕時計" suffix="件" count="{ state.count }"
                          observable="{ props.observable }" type="in_selectcategory")
            button.submit(type="button" onclick="{didClickSubmit}") >>チェックした腕時計を検索する
            button.close(type="button" onclick="{didClickClose}") ×
  style(type="scss").
    button.open {
      width: 100%;
      padding: 11px 13px;
      margin: 0 ;
      border: 0;
      background: transparent;
      color: #015205;
      font-size: 12px;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 12px;
      }
      &::after {
        content: '＞';
        color: #e28500;
        font-size: 15px;
        font-weight: bold;
        margin-bottom: -2px;
      }
      &:hover {
        background: #fef4c4;
      }
      &.sp {
        font-size: 15px;
        line-height: 15px;
        padding: 0 13px;
        span {
          font-size: 15px;
          font-weight: bold;
        }
        &::after {
          display: none;
        }
      }
    }
    ul.selected-categories {
      border-top: 2px solid #f4f4f4;
      padding-left: 14px;
      li {
        font-size: 12px;
        color: #015205;
        padding: 11px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
        border-top: 1px solid #ebebeb;
        button {
          border: 0;
          background: transparent;
          color: #c1c1c1;
          font-size: 14px;
          margin-right: 7px
        }
        &:first-child {
          border-top: 0;
        }
      }
      &.sp {
        margin-top: 18px;
        padding-right: 10px;
        li {
          font-size: 15px;
          button {
            margin-top: -4px;
            font-size: 24px;
            font-weight: bold;
          }
        }
      }
    }
    .category-selector {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 5;
      .background {
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,0.5);
      }
      .select-window {
        position: absolute;
        top: 150px;
        left: calc( (100% - 945px) / 2);
        width: 945px;
        background: white;
        table {
          border-collapse: collapse;
          border: 3px solid #c8d4a3;
          width: 945px;
          th {
            width: 190px;
            padding: 20px 18px;
            border: 1px solid #a19494;
            border-right: 2px solid #b4ca9e;
            font-size: 18px;
            color: #025b1c;
            font-weight: bold;
            text-align: left;
            vertical-align: top;
          }
          td {
            width: 753px;
            border: 1px solid #a19494;
            padding: 24px 32px 30px;
            .roots {
              border: 3px solid #e8e8e8;
              border-bottom: 0;
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
              button {
                position: relative;
                border: 0;
                background: white;
                font-size: 18px;
                width: 83px;
                border-left: 1px solid #e9e9e9;
                border-right: 1px solid #e9e9e9;
                border-bottom: 3px solid #e8e8e8;
                height: 40px;
                outline: 0;
                &:first-child {
                  border-left: 0;
                }
                &:last-child {
                  border-right: 0;
                }
                &.selected {
                  color: #025b1c;
                  font-weight: bold;
                  border-bottom-color: white;
                }
                &.selected:after {
                  content: '';
                  width: 100%;
                  border: 4px solid #84a327;
                  border-radius: 4px;
                  position: absolute;
                  top: -3px;
                  display: block;
                  left: 0;
                  z-index: 2;
                  height: 40px;
                  border-left: 0 none;
                  border-right: 0 none;
                  border-bottom: 0 none;
                  border-bottom-left-radius: 0;
                  border-bottom-right-radius: 0;
                }
              }
            }
            .brands, .models {
              padding: 38px 80px 40px;
              display: flex;
              flex-wrap: wrap;
              border: 3px solid #e8e8e8;
              width: 753px;
              label {
                font-size: 15px;
                color: #025b1c;
                font-weight: bold;
                width: 285px;
                margin-bottom: 4px;
                input {
                  margin-right: 4px;
                }
              }
            }
            .brands { border-top: 0; }
            .models {
              max-height: 200px;
              overflow-y: scroll;
            }
          }
        }
        .actions {
          background: #d4a635;
          display: flex;
          align-items: flex-end;
          padding: 12px;
          search-counter {
            margin-left: 51px;
            color: white;
            font-size: 16px;
            span { font-size: 30px; }
          }
          .submit {
            margin-left: auto;
            margin-right: 135px;

            border: 0;
            background: white;
            padding: 18px 12px;
            font-size: 18px;
            color: #025b1c;
            font-weight: bold;
            border: 1px solid #cac595;
            &:hover {
              background: #5f3d3d;
              color: white;
            }
          }
          .close {
            margin-left: auto;
            border: 0;
            border-radius: 5px;
            background: white;
            padding: 0 18px;
            font-size: 18px;
            color: #777777;
          }
        }
      }
      &.sp {
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        display: flex;
        flex-direction: column;
        * { font-family: 'Noto Sans JP', sans-serif; }
        .background {
          background: #fffef8;
        }
        .select-window {
          width: 100%;
          left: 0;
          top: 0;
          padding: 0 4.84375vw 3.28125vw;
          height: calc(100% - 17.97vw);
          background: #fffef8;
          .header {
            background: transparent;
            width: 100%;
            height: 21.09vw;
            border-bottom: 1px solid #bbbbbb;
            padding: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &-title {
              color: #6c6c6c;
              font-size: 5.46875vw;
              line-height: 1;
              font-weight: 900;
            }
            .close {
              border: 0;
              background: transparent;
              padding: 0;
              color: #115930;
              font-size: 3.75vw;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              line-height: 1;
              &-icon {
                width: 5.9375vw;
                height: 5.9375vw;
                margin-bottom: 2.03125vw;
              }
            }
          }
          .description {
            margin-top: 5vw;
            margin-bottom: 5vw;
            font-size: 3.4375vw;
            color: #7f7f7e;
          }
          .label {
            color: #6c6c6c;
            font-size: 4.69vw;
            font-weight: 700;
            padding-bottom: 2.1875vw;
            border-bottom: 2px solid #dddddd;
          }
          .brands {
            height: 50vw;
            overflow-y: scroll;
            margin-top: 5vw;
            margin-bottom: 6.25vw;
            display: flex;
            flex-direction: column;
            row-gap: 4.375vw;
            li.category {
              height: 6.4vw;
              border: 0;
              label.name {
                display: flex;
                align-items: center;
                height: 100%;
                color: #6c6c6c;
                font-size: 4.6875vw;
                font-weight: 700;
                input {
                  display: none;
                }
                .checkbox-icon {
                  height: 6.40625vw;
                  width: 6.40625vw;
                  margin-right: 1.25vw;
                  &.hidden {
                    display: none;
                  }
                }
              }
            }
            li.root-category+.category {
              margin-top: 18px;
            }
          }
          .models {
            max-height: calc(100% - 134vw);
            overflow-y: scroll;
            margin-top: 5vw;
            margin-bottom: 6.25vw;
            display: flex;
            flex-direction: column;
            row-gap: 4.375vw;
            .unselected {
              margin: 5.625vw 4.6875vw;
              color: #6c6c6c;
              font-size: 3.4375vw;
            }
            label.name {
              height: 6.4vw;
              border: 0;
              display: flex;
              align-items: center;
              color: #6c6c6c;
              font-size: 4.6875vw;
              font-weight: 700;
              margin-bottom: 0;
              input {
                display: none;
              }
              .checkbox-icon {
                height: 6.40625vw;
                width: 6.40625vw;
                margin-right: 1.25vw;
                &.hidden {
                  display: none;
                }
              }
            }
          }
        }
        .select-category {
          width: 100%;
          height: 17.97vw;
          background: #115930;
          color: #ffffff;
          font-size: 7.5vw;
          font-weight: 900;
          border: 0;
          display: grid;
          place-items: center;
        }
      }
    }
  script.
    import orangeArrow from 'tags/smartsearch/orange-arrow.png'
    import closeIcon from 'tags/smartsearch/close-icon.png'
    import checkboxOnIcon from 'tags/smartsearch/checkbox_t.png'
    import checkboxOffIcon from 'tags/smartsearch/checkbox_f.png'
    import lodash from 'lodash'

    export default {
      orangeArrow,
      closeIcon,
      checkboxOnIcon,
      checkboxOffIcon,
      onBeforeMount(props, state) {
        state.rootsAndBrands = []
        state.models = []
        state.selectedCategories = props.selectedCategories || []
        state.selectedRoot = null
        state.selectedBrands = []
        state.brandsOfSelectedModels = []
        state.selectedModels = []
        state.selectedCid = []
        state.isOpened = false
        state.count = props.count
        state.observableKeySuffix = props.observableKeySuffix || ''

        props.loader.on(props.loader.handler('root_and_brand'), (category) => {
          const rootsAndBrands = category.children()
          const selectedRoot = this.state.selectedCategories.length > 0 ?
            rootsAndBrands.find((rootAndBrands) => rootAndBrands.brands.find((brand) => brand.id === this.state.selectedCategories[0].id)) :
            rootsAndBrands[0]
          this.update({
            rootsAndBrands,
            selectedRoot
          })
        })
        props.loader.on(props.loader.handler('model'), (category) => {
          const model = { parentId: category.parent(), models: category.children() }
          let isExistModel = false
          const models = state.models
          models.forEach( (m, i, a) => {
            isExistModel = isExistModel || (m.parentId == model.parentId)
          })
          if(isExistModel) return

          models.push(model)
          models.sort((a, b) => {
            return a.parentId - b.parentId
          })
          this.update({
            models
          })
        })
        props.observable.on('onUpdateFetchedCount', (count) => {
          const fetchedCount = new Intl.NumberFormat().format(count)
          this.update({ count: fetchedCount })
        })
      },
      didSelectRoot(e) {
        const selectedRoot = this.state.rootsAndBrands[e.target.value]
        this.update({ selectedRoot })
      },
      didSelectBrand() {
        const brandElements = this.root.querySelectorAll('.brands input')
        const selectedBrands = Array.prototype.map.call(brandElements, (c) => {
          return c.checked ? c.value : ''
        }).filter(brand => brand.length > 0)

        this.update({
          selectedBrands,
        })
        selectedBrands.forEach( (e, i, a) => {
          this.props.loader.loadModelCategories(e)
        })
        this.updateSelectedCid()
      },
      didSelectModel(e) {
        const modelElements = this.root.querySelectorAll('.models input')
        const brandsOfSelectedModels = Array.prototype.map.call(modelElements, (c) => {
          return c.checked ? c.dataset.brand : ''
        }).filter(brand => brand.length > 0)
        const selectedModels = Array.prototype.map.call(modelElements, (c) => {
          return c.checked ? c.value : ''
        }).filter(model => model.length > 0)
        this.update({
          brandsOfSelectedModels,
          selectedModels
        })
        this.updateSelectedCid()
      },
      fetchBrands(brand) {
        this.props.loader.loadBrandCategories(brand.id)
      },
      cidQuery() {
        const selectedBrandIds = lodash.difference(this.state.selectedBrands, this.state.brandsOfSelectedModels)
        const selectedCid = lodash.union(selectedBrandIds, this.state.selectedModels)
        return selectedCid.join(',')
      },
      gidQuery() {
        return !!this.state.selectedReferenceGroup ? this.state.selectedReferenceGroup.id : ""
      },
      ridQuery() {
        return !!this.state.selectedReference ? this.state.selectedReference.id : ""
      },
      updateSelectedCid() {
        const selectedBrandIds = lodash.difference(this.state.selectedBrands, this.state.brandsOfSelectedModels)
        const selectedCid = lodash.union(selectedBrandIds, this.state.selectedModels)
        const selectedCategoryQuery = selectedCid.join(',')

        this.update({
          selectedCid,
          selectedCategoryQuery
        })
        this.props.onUpdate(this.cidQuery(), this.gidQuery(), this.ridQuery())
      },
      updateSelectedGid() {
        const selectedGid = !!this.state.selectedReferenceGroup ? this.state.selectedReferenceGroup.id : ""
        const selectedReferenceGroupQuery = selectedGid
        this.update({
          selectedGid,
          selectedReferenceGroupQuery
        })
        this.props.onUpdate(this.cidQuery(), this.gidQuery(), this.ridQuery())
      },
      updateSelectedRid() {
        const selectedRid = !!this.state.selectedReference ? this.state.selectedReference.id : ""
        const selectedReferenceQuery = selectedRid
        this.update({
          selectedRid,
          selectedReferenceQuery
        })
        this.props.onUpdate(this.cidQuery(), this.gidQuery(), this.ridQuery())
      },
      didClickSubmit() {
        this.props.observable.trigger(`onClickSubmitInCategoryWindow-${this.state.observableKeySuffix}`)
      },
      didClickOpen() {
        if (this.props.mobile) {
          document.querySelector(".selectcategory-window").dataset.scrollY = window.scrollY;
          document.body.style.overflow = "hidden";
        }
        this.update({
          isOpened: true
        })
        this.props.observable.trigger('onUpdateIsOpenedSelectCategoryWindow', true)
        this.initializeByExistQuery()
        this.didSelectBrand()
      },
      didClickClose() {
        if (this.props.mobile) {
          document.body.style.overflow = "auto";
          window.scrollTo(0, document.querySelector(".selectcategory-window").dataset.scrollY);
        }
        this.update({
          isOpened: false
        })
        this.props.observable.trigger('onUpdateIsOpenedSelectCategoryWindow', false)
      },
      didClickRemoveBrand(e) {
        const brandId = e.target.dataset.categoryid
        this.update({
          selectedCategories: this.state.selectedCategories.filter(brand => brand.id != brandId),
          selectedReferenceGroup: undefined,
          selectedReference: undefined
        })
        this.initializeByExistQuery()
        this.props.onUpdate(this.cidQuery(), this.gidQuery(), this.ridQuery())
        this.didClickSubmit()
      },
      didClickRemoveModel(e) {
        const modelId = e.target.dataset.categoryid
        const selectedCategories = this.state.selectedCategories.map( (brand, i, a) => {
          brand.models = brand.models.filter(model => model.id != modelId)
          return brand
        })
        this.update({
          selectedCategories,
          selectedReferenceGroup: undefined,
          selectedReference: undefined
        })
        this.initializeByExistQuery()
        this.props.onUpdate(this.cidQuery(), this.gidQuery(), this.ridQuery())
        this.didClickSubmit()
      },
      didClickRemoveReferenceGroup(e) {
        const groupId = e.target.dataset.groupid
        const selectedCategories = this.state.selectedCategories.map( (brand, i, a) => {
          brand.models = brand.models.map( (model, i, a) => {
            if (!!model.reference_group) model.reference_group = undefined
            return model
          })
          return brand
        })
        this.update({
          selectedCategories,
          selectedReferenceGroup: undefined,
          selectedReference: undefined
        })
        this.props.onUpdate(this.cidQuery(), this.gidQuery(), this.ridQuery())
        this.didClickSubmit()
      },
      didClickRemoveReference(e) {
        const refId = e.target.dataset.refid
        const selectedCategories = this.state.selectedCategories.map( (brand, i, a) => {
          brand.models = brand.models.map( (model, i, a) => {
            if (!!model.reference) model.reference = undefined
            return model
          })
          return brand
        })
        this.update({
          selectedCategories,
          selectedReference: undefined
        })
        this.props.onUpdate(this.cidQuery(), this.gidQuery(), this.ridQuery())
        this.didClickSubmit()
      },
      initializeByExistQuery() {
        if (!this.state.selectedCategories) return

        const selectedBrands = []
        const selectedModels = []
        const brandsOfSelectedModels = []
        this.state.selectedCategories.forEach( (b, i, a) => {
          if (!selectedBrands.includes(b.id)) selectedBrands.push('' + b.id)
          b.models.forEach( (m, i, a) => {
            if (!brandsOfSelectedModels.includes(b.id)) brandsOfSelectedModels.push('' + b.id)
            if (!selectedModels.includes(m.id)) selectedModels.push('' + m.id)
            if (!!m.reference_group) {
              this.state.selectedReferenceGroup = m.reference_group
              if(!!m.reference_group.reference) this.state.selectedReference = m.reference_group.reference
            } else if(!!m.reference) {
              this.state.selectedReference = m.reference
            }
          })
        })
        this.update({
          selectedBrands,
          selectedModels,
          brandsOfSelectedModels
        })
        this.update()
      },
      clickToggleBrands(e) {
        // var $ = require('jquery');
        // var categoryId = $(e.target).data("category");
        // $(".category[data-parent="+categoryId+"]").slideToggle('fast');
        // $(this).toggleClass('up');
      },
      onMounted(props, state) {
        if (document.querySelector(".select-category-button")) {
          document.querySelector(".select-category-button").addEventListener('click', this.didClickOpen)
        }
        if (document.querySelector(".search-menu_item.category")) {
          document.querySelector(".search-menu_item.category").addEventListener('click', this.didClickOpen)
        }
        this.initializeByExistQuery()
        if (!!this.state.brandsOfSelectedModels) this.updateSelectedCid()
        if (!!this.state.selectedReferenceGroup) this.updateSelectedGid()
        if (!!this.state.selectedReference) this.updateSelectedRid()
      },
      onUpdated(props, state) {
      }
    }
